import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { debugLog } from 'shared/logger/debugLog';
import { checklistSectionContract } from 'shared/domain/checklistSection/checklistSectionContract';
import { makeErrorPublisher, makeEventPublisher } from 'serviceWorker/broadcasts/publishers';

const broadcastChecklistSectionError = makeErrorPublisher(
  checklistSectionContract
);

export const broadcastCreatedChecklistSection = makeEventPublisher(checklistSectionContract, DomainMessagesTypes.checklistSectionCreated);

export const broadcastUpdatedChecklistSection = makeEventPublisher(checklistSectionContract, DomainMessagesTypes.checklistSectionUpdated);

export const broadcastDeletedChecklistSection = makeEventPublisher(checklistSectionContract, DomainMessagesTypes.checklistSectionDeleted);

export const broadcastReorderedChecklistSection = makeEventPublisher(checklistSectionContract, DomainMessagesTypes.checklistSectionReordered);

export const broadcastDeletedChecklistSectionDocument = makeEventPublisher(checklistSectionContract, DomainMessagesTypes.checklistSectionDocumentDeleted);

export const broadcastChecklistSectionOperationError = (
  error: unknown,
  uniqueId?: string,
  messageId?: string | null
): void => {
  debugLog(
    'broadcastChecklistSectionOperationError',
    error,
    uniqueId,
    messageId
  );
  broadcastChecklistSectionError(DomainMessagesTypes.failUploadedEntity, error, {
    uniqueId,
    messageId: messageId ?? undefined,
  });
};
